import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

const FAQs = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <>
      <div className="main_title">
        <h1>FAQs</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - FAQs
        </p>
      </div>
      <div className="cards">
        <section className="home_faq_sc u_spc">
          <div className="container">
            <div className="s_head text_center hd_4">
              <p>
                Frequently Asked Questions help you get quick answers about your orders, payments, shipping, and more.
                <span className="d_block">Find solutions easily below.</span>
              </p>
            </div>
            <div className="faq_lst hd_7">
              {[
                {
                  q: "How can I place an order?",
                  a: "Browse our products, add the items you want to your cart, and proceed to checkout. Enter your shipping details and payment information to complete your order.",
                  id: "p1",
                },
                {
                  q: "What payment methods are accepted?",
                  a: "We accept credit/debit cards, PayPal, Apple Pay, and other secure payment methods. All transactions are encrypted for your safety.",
                  id: "p2",
                },
                {
                  q: "How do I track my order?",
                  a: "Once your order is shipped, you will receive a tracking number via email. Use it on our website or the carrier’s site to monitor delivery status.",
                  id: "p3",
                },
                {
                  q: "Can I return or exchange a product?",
                  a: "Yes, returns and exchanges are accepted within 30 days of delivery. Ensure the product is unused and in original packaging, and follow our return process online.",
                  id: "p4",
                },
                {
                  q: "Are there discounts or promotions available?",
                  a: "We regularly offer discounts, seasonal promotions, and coupon codes. Check our homepage or subscribe to our newsletter for the latest deals.",
                  id: "p5",
                },
                {
                  q: "How do I contact customer support?",
                  a: "You can reach our support team via live chat, email, or phone. Visit the “Contact Us” page for more details.",
                  id: "p6",
                },
              ].map((item) => (
                <Accordion
                  key={item.id}
                  expanded={expanded === item.id}
                  onChange={handleChange(item.id)}
                  className="faq_bx"
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <h3>{item.q}</h3>
                  </AccordionSummary>
                  <AccordionDetails>{item.a}</AccordionDetails>
                </Accordion>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FAQs;
